import authRules from '../authRules.js';

const viewCalendar = (user) => {
  const { resourceDayTypes } = user.securityLevels;
  if (resourceDayTypes >= authRules.viewCalendar.resourceDayTypes) {
      return true;
  } else {
      return false;
    }
  }


export default viewCalendar;